import React, { Component } from 'react';
import { Segment, Loader, Dimmer, Header, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { parse } from 'qs';
import * as actionCreators from './actions';

const STATE_NEW = 'new';
const STATE_PROCESSING = 'processing';
const STATE_COMPLETED = 'completed';
const STATE_FAILED = 'failed';
const STATE_CANCELLED = 'cancelled';
const STATE_REFUNDED = 'refunded';
const STATE_UNKNOWN = 'unknown';

function getPaymentStatus(status) {
  switch (status) {
    case STATE_PROCESSING:
      return 'Payment is being processed. Funds will be added to your wallet after payment is completed.';
    case STATE_COMPLETED:
      return 'Payment is completed. Funds has been added to your wallet.';
    case STATE_FAILED:
      return 'Payment has failed. Please make another one.';

    default:
      return '';
  }
}
class Payment extends Component {
  componentDidMount() {
    const params = parse(this.props.location.search, {
      ignoreQueryPrefix: true
    });

    this.props.getPayment(params.paymentId);
  }

  componentDidUpdate() {
    const { payment } = this.props;

    if (payment.state === STATE_COMPLETED) {
      this.props.registerPayment(payment);
    }
  }

  render() {
    const { phase, payment } = this.props;
    if (phase === 'LOADING') {
      return (
        <Dimmer page active>
          <Loader />
        </Dimmer>
      );
    }
    return (
      <Segment>
        <Header as="h1">Payment status</Header>
        <p>{getPaymentStatus(payment.state)}</p>
        <Button onClick={() => this.props.history.push('/wallet')}>
          Go to wallet
        </Button>
      </Segment>
    );
  }
}
const mapStateToProps = state => {
  return {
    payment: state.payment.data,
    phase: state.payment.phase
  };
};

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(actionCreators, dispatch)
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Payment);



// WEBPACK FOOTER //
// ./src/payment/index.js